import { Chip, Stack } from '@mui/material';
import { ReactElement } from 'react';
import { FunctionField, FunctionFieldProps, RaRecord } from 'react-admin';
import { Flag } from '../../utils';
import { get } from 'lodash';
import { getMatchingFlags } from './utils';

interface ShopScanStatusTagsProps extends Omit<FunctionFieldProps, 'render'> {
  flags: Flag[];
}
export default function BitmaskTagsField({
  source,
  label,
  flags,
}: ShopScanStatusTagsProps): ReactElement {
  return (
    <FunctionField
      source={source}
      label={label}
      render={(record: RaRecord) => {
        if (!source) return null;
        const value = get(record, source);
        const tags = getMatchingFlags(value, flags);
        return (
          <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap">
            {tags.map(({ id, name, color }, i) => (
              <Chip key={`${id}-${i}`} label={name} size="small" color={color} />
            ))}
          </Stack>
        );
      }}
    />
  );
}
